export const DEV_LANGUAGES = [
    'AppSheet', 'Sheets', 'HTML', 'Javascript', 'Apps Script',
    'Python', 'Typescript', 'Big Query SQL', 'React', 'Vite', 'Markdown', 'JSON'
];

export const AI_LANGUAGES = [
    'Prompt', 'Gem', 'System Prompt', 'Context', 'Few-Shot', 'AI Code'
];

export const LINK_TYPES = [
    'GitHub Repo', 'Dev Docs', 'Community Forum', 'Applications', 'cURL commands'
];

export const TOOL_TYPES = [
    'JWT Decoder', 'JSON Formatter', 'Boilerplate Gen', 'Regex Tester',
    'Base64 & URL', 'Color Converter', 'Hash Generator', 'Mock Data Gen',
    'Case Converter', 'Markdown Pad'
];

export const INITIAL_SNIPPET = {
    title: '', content: '', type: 'AppSheet', history: [], tags: [], vault: 'dev',
    gemPremise: '', gemPersona: '', gemContext: '', gemRules: '',
    outputFormat: 'Markdown Table', tone: 'Professional', temp: '0.7',
    source: '', pattern: '', url: '',
    toolOutput: '', visibility: 'private', orgId: null, teamId: null
};